module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_006.png
// module id = 929
// module chunks = 0